import { render } from "./AppSingleProduct.vue?vue&type=template&id=40d3145d&scoped=true"
import script from "./AppSingleProduct.vue?vue&type=script&lang=js"
export * from "./AppSingleProduct.vue?vue&type=script&lang=js"

import "./AppSingleProduct.vue?vue&type=style&index=0&id=40d3145d&lang=scss&scoped=true"

import exportComponent from "/Users/flegate/Serveur/Sites/welcom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d3145d"]])

export default __exports__